import {useState} from 'react'
import {useCustomQuery} from '@salesforce/commerce-sdk-react'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

/** Fetch store availability data */
const useFindInStore = ({productId = '', address = '', lat = '', lng = '', geoPermission = false}) => {
    const {site, locale} = useMultiSite()

    const [findInStoreData, setFindInStoreData] = useState([])
    const [isFindInStoreLoading, setFindInStoreLoading] = useState(false)

    const baseOptions = {
        method: 'POST',
        parameters: {siteId: site.id},
        customApiPathParameters: {
            apiVersion: 'v1',
            endpointPath: '/find-in-store',
            apiName: 'find-in-store'
        }
    }

    const {refetch: refetchFindInStore} = useCustomQuery(
        {
            options: {
                ...baseOptions,
                body: JSON.stringify({sku: productId, address, lat, lng, geoPermission})
            },
            rawResponse: false
        },
        {enabled: false}
    )

    /** Imperative fetch that switches automatically between address or geo mode */
    const fetchStores = async ({productId, address, lat, lng}) => {
        const usingGeo = lat && lng
        let geoPermission = false

        await navigator.permissions.query({name: 'geolocation'}).then((status) => {
            geoPermission = status.state == 'granted'
        })

        const payload = {
            sku: productId,
            ...(usingGeo ? {lat, lng, geoPermission} : {address, geoPermission})
        }

        setFindInStoreLoading(true)
        try {
            const result = await refetchFindInStore({
                options: {...baseOptions, body: JSON.stringify(payload)}
            })
            setFindInStoreData(result.data)
        } catch (e) {
            console.error(e)
        } finally {
            setFindInStoreLoading(false)
        }
    }

    return {isFindInStoreLoading, findInStoreData, fetchStores}
}

export {useFindInStore}
